// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zGUdXm13hMfown {\n  margin-left: 40px;\n}\n@media only screen and (max-width: 750px) {\n  .zGUdXm13hMfown {\n    margin-left: 0;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gutter": "zGUdXm13hMfown"
};
export default ___CSS_LOADER_EXPORT___;
